import {
  GoabFormItem,
  GoabInput,
  GoabContainer,
  GoabSpacer,
} from "@abgov/react-components";

import { useGenerationForm } from "../../hooks";

export const EmailSection = () => {
  const {
    fieldValues,
    fieldErrors,
    fieldTouches,
    handleBlur,
    handleEmailChange,
    isReady,
  } = useGenerationForm("PersonalInformation");

  // Early return if form not ready.
  if (!isReady) return null;

  const emailError = fieldTouches.email && fieldErrors.email;

  return (
    <>
      <GoabContainer accent="thin">
        <h3>Add your email address</h3>
        <GoabSpacer vSpacing="l" />
        <GoabFormItem label="Email Address" error={fieldErrors.email}>
          <GoabInput
            onChange={({name, value}) => handleEmailChange(name, value)}
            onBlur={({name, value}) => handleBlur(name)}
            value={fieldValues.email || ""}
            name="email"
            type="email"
            error={!!emailError}
          ></GoabInput>
        </GoabFormItem>
      </GoabContainer>
      <GoabSpacer vSpacing="2xs" />
    </>
  );
};
